<style scoped>
</style>

<template>
    <v-navigation-drawer v-model="open" app temporary :right="true" style="z-index:11;">        
        <v-list-item class="pa-2 pl-4 pr-4 pb-1" style="border-bottom: 1px solid #cccccc;">
            <v-btn icon @click="drawerOpen({ show: false })">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-list-item-title class="text-h5" style="text-align:center;">
                Profile
            </v-list-item-title>
            <person-avatar size="32" :avatar="$user.avatar" :name="$user.name"></person-avatar>            
        </v-list-item>
        <v-list>
            <template v-for="item in menu.items">
                <v-list-group v-if="item.children" v-model="item.active" :key="item.name + '-parent'" style="margin-bottom:8px;">
                    <template v-slot:activator>
                        <v-list-item-icon>
                            <v-icon v-text="item.meta.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.meta.title"></v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item link :ripple="false" v-for="child in filterChildren(item.children)" :to="{ name: child.name }" :key="child.name" style="background-color:var(--v-primary-lighten5) !important;">
                        <v-list-item-icon>
                            <v-icon v-text="child.meta.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="child.meta.title"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item link color="secondary" v-else :to="{ name: item.name }" :key="item.name">
                    <v-list-item-icon>
                        <v-icon v-text="item.meta.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.meta.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>

            <template v-if="$user.role == 'admin' && menu.adminItems.length > 0">
                <v-divider class="mt-2"></v-divider>
                <div style="text-align:center;" class="pt-4">
                    <strong>Admin Tools</strong>
                </div>            
                <template v-for="item in menu.adminItems">
                    <v-list-group v-if="item.children" v-model="item.active" :key="item.name + '-parent'" style="margin-bottom:8px;background-color:red !important;">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon v-text="item.meta.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.meta.title"></v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item link :ripple="false" v-for="child in filterChildren(item.children)" :to="{ name: child.name }" :key="child.name">
                            <v-list-item-icon>
                                <v-icon v-text="child.meta.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="child.meta.title"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item link color="secondary" v-else :to="{ name: item.name }" :key="item.name">
                        <v-list-item-icon>
                            <v-icon v-text="item.meta.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.meta.title"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </template>          
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import personAvatar from '../../domains/person/person.avatar.vue';
import events from "../app.events";
import tools from "../../util/tools.utils";

export default { 
    data: function () {
        return {
            open: false,
            menu: {
                items: [
                ],
                adminItems: []
            },
        }
    },
    mounted: function () {
        this.menu.items = this.getRoutes("app", false);
        console.log(this.menu.items);        
        this.menu.adminItems = this.getRoutes("app", true);         
    },
    created: function () {
        this.$bus.handle(events.APP_DRAWER_OPEN, this.drawerOpen.bind(this));        
        this.$bus.handle(events.APP_DRAWER_TOGGLE, this.drawerToggle.bind(this));        
    },
    computed: {
    },
    methods: {
        getRoutes(parentName, admin) {
            var routes = this.$router.resolveByNameWithChildren(parentName);

            var filteredRoutes = tools.deepCopy(routes.children);
            if (admin) {
                filteredRoutes = filteredRoutes.filter(r => !r.meta.hide && r.meta.admin);
            }
            else {
                filteredRoutes = filteredRoutes.filter(r => !r.meta.hide && !r.meta.admin);
            }
            return filteredRoutes;
        },
        filterChildren(routes) {
            var filteredRoutes = routes.filter(r => !r.meta.hide);
            return filteredRoutes;
        },         
        drawerOpen({ show }) {
            this.open = show;
        },
        drawerToggle() {
            this.open = !this.open;
        },
        getName() {
            if (!this.$user || !this.$user.name) {
                return "?";
            }

            var names = this.$user.name.split(" ");

            var initials = names[1].substring(0, 1);
            if (names.length > 2) {
                initials += names[2].substring(0, 1);
            }
            return initials;
        },
        getImage() {
            return this.$asset.getUrl(this.$user.avatar, "thumbnail");
        }        
    },
    components: { 
        personAvatar
    }
}
</script>